/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom';

function id(original) {
  return original?.id || '';
}

function serviceProviderId(original) {
  return original?.serviceProviderId || '';
}

function createdByUserId(original) {
  return original?.createdByUserId || '';
}

function lastModifiedByUserId(original) {
  return original?.lastModifiedByUserId || '';
}

function locationName(original, props, accessorFunctionsAdditional) {
  return (
    <Link to={accessorFunctionsAdditional.navigate(original.id)}>
      {original?.locationName || ''}
    </Link>
  );
}

function locationNumber(original) {
  return original?.locationNumber || '';
}

function isDefaultLocation(original) {
  return original?.isDefaultLocation ? 'Yes' : 'No';
}

function status(original) {
  switch (original?.status) {
    case 'ACTIVE':
      return 'Active';
    case 'INACTIVE':
      return 'In-Active';
    default:
      return 'Unknown';
  }
}

export {
  id,
  serviceProviderId,
  createdByUserId,
  lastModifiedByUserId,
  locationName,
  locationNumber,
  isDefaultLocation,
  status,
};
